import BandeiraALE from "assets/icons/ALE.png";
import BandeiraANG from "assets/icons/ANG.png";
import BandeiraARG from "assets/icons/ARG.jpg";
import BandeiraAUS from "assets/icons/AUS.png";
import BandeiraBLZ from "assets/icons/BLZ.png";
import BandeiraBM from "assets/icons/BMU.png";
import BandeiraBRA from "assets/icons/BRA.png";
import BandeiraBRB from "assets/icons/BRB.png";
import BandeiraCAN from "assets/icons/CAN.png";
import BandeiraCHI from "assets/icons/CHI.png";
import BandeiraCHN from "assets/icons/CHN.png";
import BandeiraCOL from "assets/icons/COL.png";
import BandeiraCRI from "assets/icons/CRI.png";
import BandeiraDMA from "assets/icons/DMA.png";
import BandeiraDOM from "assets/icons/DOM.png";
import BandeiraDUB from "assets/icons/DUB.png";
import BandeiraESP from "assets/icons/ESP.png";
import BandeiraEUA from "assets/icons/EUA.png";
import BandeiraFJI from "assets/icons/FJI.png";
import BandeiraFRA from "assets/icons/FRA.png";
import BandeiraGBR from "assets/icons/GBR.png";
import BandeiraGRD from "assets/icons/GRD.png";
import BandeiraIND from "assets/icons/IND.png";
import BandeiraIRL from "assets/icons/IRL.png";
import BandeiraITA from "assets/icons/ITA.png";
import BandeiraJAM from "assets/icons/JAM.png";
import BandeiraMEX from "assets/icons/MEX.png";
import BandeiraMLT from "assets/icons/MLT.png";
import BandeiraNLD from "assets/icons/NLD.png";
import BandeiraNZL from "assets/icons/NZL.png";
import BandeiraPAN from "assets/icons/PAN.png";
import BandeiraPAR from "assets/icons/PAR.png";
import BandeiraPER from "assets/icons/PER.png";
import BandeiraPHL from "assets/icons/PHL.png";
import BandeiraPNG from "assets/icons/PNG.png";
import BandeiraPOR from "assets/icons/POR.png";
import BandeiraSLB from "assets/icons/SLB.png";
import BandeiraURU from "assets/icons/URU.png";
import BandeiraVEN from "assets/icons/VEN.png";

export const countries = [
  {
    prefix: "BRA",
    ddi: "+55",
    flag: BandeiraBRA,
    maxLength: 11,
    phoneTypeAuthVerify: "sms",
    removePrefix: false,
    phoneExtraPrefixNumber: null,
    phonePositionNumberExtraPrefix: null,
    pattern: {
      mask: "(XX) XXXXX-XXXX",
      regex: /^\(\d{2}\)\s\d{5}-\d{4}$/,
      maxLength: 15
    }
  },
  {
    prefix: "EUA",
    ddi: "+1",
    flag: BandeiraEUA,
    maxLength: 10,
    phoneTypeAuthVerify: "sms",
    removePrefix: false,
    phoneExtraPrefixNumber: null,
    phonePositionNumberExtraPrefix: null,
    pattern: {
      mask: "(XXX) XXX-XXXX",
      regex: /^\(\d{3}\)\s\d{3}-\d{4}$/,
      maxLength: 14
    }
  },
  {
    prefix: "CAN",
    ddi: "+1",
    flag: BandeiraCAN,
    maxLength: 10,
    phoneTypeAuthVerify: "sms",
    removePrefix: false,
    phoneExtraPrefixNumber: null,
    phonePositionNumberExtraPrefix: null,
    pattern: {
      mask: "(XXX) XXX-XXXX",
      regex: /^\(\d{3}\)\s\d{3}-\d{4}$/,
      maxLength: 14
    }
  },
  {
    prefix: "BMU",
    ddi: "+1",
    flag: BandeiraBM,
    maxLength: 10,
    phoneTypeAuthVerify: "sms",
    removePrefix: false,
    phoneExtraPrefixNumber: 441,
    phonePositionNumberExtraPrefix: 0,
    pattern: {
      mask: "XXX XXX XXXX",
      regex: /^\d{3}\s\d{3}\s\d{4}$/,
      maxLength: 12
    }
  },
  {
    prefix: "BRB",
    ddi: "+1",
    flag: BandeiraBRB,
    maxLength: 10,
    phoneTypeAuthVerify: "sms",
    removePrefix: false,
    phoneExtraPrefixNumber: 246,
    phonePositionNumberExtraPrefix: 0,
    pattern: {
      mask: "XXX XXX XXXX",
      regex: /^\d{3}\s\d{3}\s\d{4}$/,
      maxLength: 12
    }
  },
  {
    prefix: "GRD",
    ddi: "+1",
    flag: BandeiraGRD,
    maxLength: 10,
    phoneTypeAuthVerify: "sms",
    removePrefix: false,
    phoneExtraPrefixNumber: 473,
    phonePositionNumberExtraPrefix: 0,
    pattern: {
      mask: "XXX XXX XXXX",
      regex: /^\d{3}\s\d{3}\s\d{4}$/,
      maxLength: 12
    }
  },
  {
    prefix: "DMA",
    ddi: "+1",
    flag: BandeiraDMA,
    maxLength: 10,
    phoneTypeAuthVerify: "sms",
    removePrefix: false,
    phoneExtraPrefixNumber: 767,
    phonePositionNumberExtraPrefix: 0,
    pattern: {
      mask: "XXX XXX XXXX",
      regex: /^\d{3}\s\d{3}\s\d{4}$/,
      maxLength: 12
    }
  },
  {
		prefix: "DOM",
		ddi: "+1",
		flag: BandeiraDOM,
		maxLength: 10,
		phoneTypeAuthVerify: "sms",
		removePrefix: false,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "(XXX) XXX XXXX",
			regex: /^\((809|829|849)\)\s\d{3}\s\d{4}$/,
			maxLength: 14,
		},
	},
  {
    prefix: "JAM",
    ddi: "+1",
    flag: BandeiraJAM,
    maxLength: 10,
    phoneTypeAuthVerify: "sms",
    removePrefix: false,
    phoneExtraPrefixNumber: 876,
    phonePositionNumberExtraPrefix: 0,
    pattern: {
      mask: "XXX XXX XXXX",
      regex: /^\d{3}\s\d{3}\s\d{4}$/,
      maxLength: 12
    }
  },
  {
    prefix: "NLD",
    ddi: "+31",
    flag: BandeiraNLD,
    maxLength: 9,
    phoneTypeAuthVerify: "sms",
    removePrefix: false,
    phoneExtraPrefixNumber: null,
    phonePositionNumberExtraPrefix: null,
    pattern: {
      mask: "X-XXXX-XXXX",
      regex: /^\d{1}-\d{4}-\d{4}$/,
      maxLength: 11
    }
  },
  {
    prefix: "FRA",
    ddi: "+33",
    flag: BandeiraFRA,
    maxLength: 9,
    phoneTypeAuthVerify: "sms",
    removePrefix: false,
    phoneExtraPrefixNumber: null,
    phonePositionNumberExtraPrefix: null,
    pattern: {
      mask: "X XX XX XX XX",
      regex: /^\d{1}\s\d{2}\s\d{2}\s\d{2}\s\d{2}$/,
      maxLength: 14
    }
  },
  {
    prefix: "ESP",
    ddi: "+34",
    flag: BandeiraESP,
    maxLength: 9,
    phoneTypeAuthVerify: "sms",
    removePrefix: false,
    phoneExtraPrefixNumber: null,
    phonePositionNumberExtraPrefix: null,
    pattern: {
      mask: "XXX XXX XXX",
      regex: /^\d{3}\s\d{3}\s\d{3}$/,
      maxLength: 11
    }
  },
  {
    prefix: "ITA",
    ddi: "+39",
    flag: BandeiraITA,
    maxLength: 10,
    phoneTypeAuthVerify: "sms",
    removePrefix: false,
    phoneExtraPrefixNumber: null,
    phonePositionNumberExtraPrefix: null,
    pattern: {
      mask: "XXX XXX XXXX",
      regex: /^\d{3}\s\d{3}\s\d{4}$/,
      maxLength: 12
    }
  },
  {
    prefix: "GBR",
    ddi: "+44",
    flag: BandeiraGBR,
    maxLength: 10,
    phoneTypeAuthVerify: "sms",
    removePrefix: false,
    phoneExtraPrefixNumber: null,
    phonePositionNumberExtraPrefix: null,
    pattern: {
      mask: "XXXX XXXXXX",
      regex: /^\d{4}\s\d{6}$/,
      maxLength: 11
    }
  },
  {
    prefix: "ALE",
    ddi: "+49",
    flag: BandeiraALE,
    maxLength: 10,
    phoneTypeAuthVerify: "sms",
    removePrefix: false,
    phoneExtraPrefixNumber: null,
    phonePositionNumberExtraPrefix: null,
    pattern: {
      mask: "XXX XXXXXXX",
      regex: /^\d{3}\s\d{7}$/,
      maxLength: 11
    }
  },
  {
    prefix: "PER",
    ddi: "+51",
    flag: BandeiraPER,
    maxLength: 9,
    phoneTypeAuthVerify: "sms",
    removePrefix: true,
    phoneExtraPrefixNumber: 9,
    phonePositionNumberExtraPrefix: 0,
    pattern: {
      mask: "XXX XXX-XXX",
      regex: /^\d{3}\s\d{3}-\d{3}$/,
      maxLength: 11
    }
  },
  {
    prefix: "MEX",
    ddi: "+52",
    flag: BandeiraMEX,
    maxLength: 10,
    phoneTypeAuthVerify: "sms",
    removePrefix: false,
    phoneExtraPrefixNumber: null,
    phonePositionNumberExtraPrefix: null,
    pattern: {
      mask: "(XXX) XXX-XXXX",
      regex: /^\(\d{3}\)\s\d{3}-\d{4}$/,
      maxLength: 14
    }
  },
  {
    prefix: "ARG",
    ddi: "+54",
    flag: BandeiraARG,
    maxLength: 11,
    phoneTypeAuthVerify: "sms",
    removePrefix: false,
    phoneExtraPrefixNumber: null,
    phonePositionNumberExtraPrefix: null,
    pattern: {
      mask: "X (XX) XXXX-XXXX",
      regex: /^[9]\s\(\d{2}\)\s\d{4}-\d{4}$/,
      maxLength: 16
    }
  },
  {
    prefix: "CHI",
    ddi: "+56",
    flag: BandeiraCHI,
    maxLength: 9,
    phoneTypeAuthVerify: "sms",
    removePrefix: true,
    phoneExtraPrefixNumber: 9,
    phonePositionNumberExtraPrefix: 0,
    pattern: {
      mask: "X XXXX-XXXX",
      regex: /^\d{1}\s\d{4}-\d{4}$/,
      maxLength: 11
    }
  },
  {
    prefix: "COL",
    ddi: "+57",
    flag: BandeiraCOL,
    maxLength: 10,
    phoneTypeAuthVerify: "sms",
    removePrefix: true,
    phoneExtraPrefixNumber: 3,
    phonePositionNumberExtraPrefix: 0,
    pattern: {
      mask: "(XXX) XXX-XXXX",
      regex: /^\(\d{3}\)\s\d{3}-\d{4}$/,
      maxLength: 14
    }
  },
  {
    prefix: "VEN",
    ddi: "+58",
    flag: BandeiraVEN,
    maxLength: 10,
    phoneTypeAuthVerify: "sms",
    removePrefix: true,
    phoneExtraPrefixNumber: 4,
    phonePositionNumberExtraPrefix: 0,
    pattern: {
      mask: "XXX XXX XXXX",
      regex: /^\d{3}\s\d{3}\s\d{4}$/,
      maxLength: 13
    }
  },
  {
    prefix: "AUS",
    ddi: "+61",
    flag: BandeiraAUS,
    maxLength: 9,
    phoneTypeAuthVerify: "sms",
    removePrefix: false,
    phoneExtraPrefixNumber: 4,
    phonePositionNumberExtraPrefix: null,
    pattern: {
      mask: "XXX XXX XXX",
      regex: /^\d{3}\s\d{3}\s\d{3}$/,
      maxLength: 11
    }
  },
  {
    prefix: "PHL",
    ddi: "+63",
    flag: BandeiraPHL,
    maxLength: 10,
    phoneTypeAuthVerify: "sms",
    removePrefix: false,
    phoneExtraPrefixNumber: null,
    phonePositionNumberExtraPrefix: null,
    pattern: {
      mask: "XXX XXX XXXX",
      regex: /^\d{3}\s\d{3}\s\d{4}$/,
      maxLength: 12
    }
  },
  {
    prefix: "NZL",
    ddi: "+64",
    flag: BandeiraNZL,
    maxLength: 9,
    phoneTypeAuthVerify: "sms",
    removePrefix: false,
    phoneExtraPrefixNumber: 2,
    phonePositionNumberExtraPrefix: null,
    pattern: {
      mask: "XX XXX XXXX",
      regex: /^\d{2}\s\d{3}\s\d{4}$/,
      maxLength: 11
    }
  },
  {
    prefix: "CHN",
    ddi: "+86",
    flag: BandeiraCHN,
    maxLength: 11,
    phoneTypeAuthVerify: "sms",
    removePrefix: false,
    phoneExtraPrefixNumber: 1,
    phonePositionNumberExtraPrefix: null,
    pattern: {
      mask: "XXX XXXX XXXX",
      regex: /^\d{3}\s\d{4}\s\d{4}$/,
      maxLength: 13
    }
  },
  {
    prefix: "IND",
    ddi: "+91",
    flag: BandeiraIND,
    maxLength: 10,
    phoneTypeAuthVerify: "sms",
    removePrefix: false,
    phoneExtraPrefixNumber: null,
    phonePositionNumberExtraPrefix: null,
    pattern: {
      mask: "XXXXX-XXXXX",
      regex: /^\d{5}-\d{5}$/,
      maxLength: 11
    }
  },
  {
    prefix: "ANG",
    ddi: "+244",
    flag: BandeiraANG,
    maxLength: 9,
    phoneTypeAuthVerify: "sms",
    removePrefix: false,
    phoneExtraPrefixNumber: null,
    phonePositionNumberExtraPrefix: null,
    pattern: {
      mask: "XXX XXX XXX",
      regex: /^\d{3}\s\d{3}\s\d{3}$/,
      maxLength: 11
    }
  },
  {
    prefix: "POR",
    ddi: "+351",
    flag: BandeiraPOR,
    maxLength: 9,
    phoneTypeAuthVerify: "sms",
    removePrefix: false,
    phoneExtraPrefixNumber: null,
    phonePositionNumberExtraPrefix: null,
    pattern: {
      mask: "XXX XXX XXX",
      regex: /^\d{3}\s\d{3}\s\d{3}$/,
      maxLength: 11
    }
  },
  {
    prefix: "IRL",
    ddi: "+353",
    flag: BandeiraIRL,
    maxLength: 9,
    phoneTypeAuthVerify: "sms",
    removePrefix: false,
    phoneExtraPrefixNumber: null,
    phonePositionNumberExtraPrefix: null,
    pattern: {
      mask: "XX XXX XXXX",
      regex: /^\d{2}\s\d{3}\s\d{4}$/,
      maxLength: 11
    }
  },
  {
    prefix: "MLT",
    ddi: "+356",
    flag: BandeiraMLT,
    maxLength: 8,
    phoneTypeAuthVerify: "sms",
    removePrefix: false,
    phoneExtraPrefixNumber: null,
    phonePositionNumberExtraPrefix: null,
    pattern: {
      mask: "XX XX XX XX",
      regex: /^[7]\d{1}\s\d{2}\s\d{2}\s\d{2}$/,
      maxLength: 11
    }
  },
  {
    prefix: "BLZ",
    ddi: "+501",
    flag: BandeiraBLZ,
    maxLength: 7,
    phoneTypeAuthVerify: "sms",
    removePrefix: true,
    phoneExtraPrefixNumber: 6,
    phonePositionNumberExtraPrefix: 0,
    pattern: {
      mask: "XXX-XXXX",
      regex: /^\d{3}-\d{4}$/,
      maxLength: 8
    }
  },
  {
    prefix: "CRI",
    ddi: "+506",
    flag: BandeiraCRI,
    maxLength: 8,
    phoneTypeAuthVerify: "sms",
    removePrefix: false,
    phoneExtraPrefixNumber: null,
    phonePositionNumberExtraPrefix: null,
    pattern: {
      mask: "XXXX-XXXX",
      regex: /^\d{4}-\d{4}$/,
      maxLength: 9
    }
  },
  {
    prefix: "PAN",
    ddi: "+507",
    flag: BandeiraPAN,
    maxLength: 8,
    phoneTypeAuthVerify: "sms",
    removePrefix: false,
    phoneExtraPrefixNumber: null,
    phonePositionNumberExtraPrefix: null,
    pattern: {
      mask: "XXXX-XXXX",
      regex: /^\d{4}-\d{4}$/,
      maxLength: 9
    }
  },
  {
    prefix: "PAR",
    ddi: "+595",
    flag: BandeiraPAR,
    maxLength: 9,
    phoneTypeAuthVerify: "sms",
    removePrefix: false,
    phoneExtraPrefixNumber: null,
    phonePositionNumberExtraPrefix: null,
    pattern: {
      mask: "X XXXX-XXXX",
      regex: /^\d{1}\s\d{4}-\d{4}$/,
      maxLength: 11
    }
  },
  {
    prefix: "URU",
    ddi: "+598",
    flag: BandeiraURU,
    maxLength: 8,
    phoneTypeAuthVerify: "sms",
    removePrefix: false,
    phoneExtraPrefixNumber: null,
    phonePositionNumberExtraPrefix: null,
    pattern: {
      mask: "X XXX-XXXX",
      regex: /^\d{1}\s\d{3}-\d{4}$/,
      maxLength: 10
    }
  },
  {
    prefix: "PNG",
    ddi: "+675",
    flag: BandeiraPNG,
    maxLength: 7,
    phoneTypeAuthVerify: "sms",
    removePrefix: false,
    phoneExtraPrefixNumber: 7,
    phonePositionNumberExtraPrefix: null,
    pattern: {
      mask: "XXX XXXX",
      regex: /^\d{3}\s\d{4}$/,
      maxLength: 8
    }
  },
  {
    prefix: "SLB",
    ddi: "+677",
    flag: BandeiraSLB,
    maxLength: 8,
    phoneTypeAuthVerify: "sms",
    removePrefix: false,
    phoneExtraPrefixNumber: 7,
    phonePositionNumberExtraPrefix: null,
    pattern: {
      mask: "XXXX XXXX",
      regex: /^\d{4}\s\d{4}$/,
      maxLength: 9
    }
  },
  {
    prefix: "FJI",
    ddi: "+679",
    flag: BandeiraFJI,
    maxLength: 7,
    phoneTypeAuthVerify: "sms",
    removePrefix: false,
    phoneExtraPrefixNumber: null,
    phonePositionNumberExtraPrefix: null,
    pattern: {
      mask: "XXX XXXX",
      regex: /^[789]\d{2}\s\d{4}$/,
      maxLength: 8
    }
  },
  {
    prefix: "DUB",
    ddi: "+971",
    flag: BandeiraDUB,
    maxLength: 9,
    phoneTypeAuthVerify: "sms",
    removePrefix: false,
    phoneExtraPrefixNumber: null,
    phonePositionNumberExtraPrefix: null,
    pattern: {
      mask: "(XX) XXX XXXX",
      regex: /^\(\d{2}\)\s\d{3}\s\d{4}$/,
      maxLength: 13
    }
  }
];
